import React from 'react';
import HeroSection3 from '../components/herosections/HeroSection3';
import TrustedBrands from '../components/home/TrustedBrands';
import AboutUs from '../components/home/AboutUs';
import Services from '../components/home/Services';
import Team from '../components/home/Team';
import FAQs from '../components/home/FAQs';
import Blog from '../components/home/Blog';

const Home3 = () => {
    return (
        <>
            <HeroSection3 />
            <TrustedBrands />
            <AboutUs />
            <Services />
            <Team />
            <Blog />
            <FAQs />
        </>
    )
}

export default Home3;
